import { useState } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { useOdooAuth } from '@/lib/OdooAuthContext';
import SubPageHeader from '../SubPageHeader';
import SettingsRow from '../SettingsRow';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function AccountSection({ onBack }) {
  const { user } = useAuth();
  const { odooSession } = useOdooAuth();
  const [editing, setEditing] = useState(false);
  const [phone, setPhone] = useState(odooSession?.phone || '');
  const [mobile, setMobile] = useState(odooSession?.mobile || '');

  const handleSave = () => {
    setEditing(false);
    toast.success('تم حفظ التغييرات');
  };

  const name = odooSession?.name || user?.full_name || 'المستخدم';
  const email = odooSession?.email || user?.email || '';
  const roleLabel = user?.role === 'manager' ? 'مدير' : 'مندوب';

  return (
    <div className="flex flex-col min-h-full" dir="rtl">
      <SubPageHeader title="الحساب الشخصي" onBack={onBack} />
      <div className="p-4 space-y-4">

        {/* Avatar + Info */}
        <div className="bg-card border border-border rounded-2xl p-5 flex flex-col items-center gap-3">
          <div className="relative">
            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center">
              <span className="text-primary font-black text-3xl">{name.charAt(0)}</span>
            </div>
          </div>
          <div className="text-center">
            <p className="font-bold text-lg text-foreground">{name}</p>
            <span className="text-xs bg-primary/10 text-primary px-3 py-1 rounded-full font-medium inline-block mt-1">{roleLabel}</span>
            <p className="text-sm text-muted-foreground mt-1">{email}</p>
          </div>
        </div>

        {/* Editable Info */}
        <div className="bg-card border border-border rounded-2xl p-4 space-y-1">
          <div className="flex items-center justify-between mb-3">
            <p className="font-bold text-sm text-foreground">معلومات الاتصال</p>
            <button onClick={() => setEditing(e => !e)} className="text-xs text-primary font-semibold">
              {editing ? 'إلغاء' : '✏️ تعديل'}
            </button>
          </div>
          {editing ? (
            <div className="space-y-3">
              <div>
                <label className="text-xs text-muted-foreground mb-1 block">الهاتف</label>
                <Input value={phone} onChange={e => setPhone(e.target.value)} className="rounded-xl" placeholder="رقم الهاتف" />
              </div>
              <div>
                <label className="text-xs text-muted-foreground mb-1 block">الموبايل</label>
                <Input value={mobile} onChange={e => setMobile(e.target.value)} className="rounded-xl" placeholder="رقم الموبايل" />
              </div>
              <Button onClick={handleSave} className="w-full rounded-xl">حفظ التغييرات</Button>
            </div>
          ) : (
            <>
              <SettingsRow icon="📧" label="البريد الإلكتروني" value={email} />
              <SettingsRow icon="📞" label="الهاتف" value={phone || 'غير محدد'} />
              <SettingsRow icon="📱" label="الموبايل" value={mobile || 'غير محدد'} />
            </>
          )}
        </div>

        {/* Work Info */}
        <div className="bg-card border border-border rounded-2xl p-4 space-y-1">
          <p className="font-bold text-sm text-foreground mb-3">بيانات العمل</p>
          <SettingsRow icon="🏢" label="فريق المبيعات" value={odooSession?.team || 'غير محدد'} />
          <SettingsRow icon="👔" label="المنصب" value={odooSession?.job_title || roleLabel} />
          <SettingsRow icon="🆔" label="معرف المستخدم في Odoo" value={`#${odooSession?.uid || '—'}`} />
        </div>

        {/* Targets */}
        <div className="bg-card border border-border rounded-2xl p-4">
          <p className="font-bold text-sm text-foreground mb-3">📊 الأهداف الشهرية</p>
          <div className="grid grid-cols-2 gap-3">
            {[
              { label: 'المبيعات', value: '—', icon: '🛒' },
              { label: 'الزيارات', value: '—', icon: '📍' },
              { label: 'التحصيلات', value: '—', icon: '💰' },
              { label: 'التغطية', value: '—', icon: '🗺️' },
            ].map(t => (
              <div key={t.label} className="bg-muted/40 rounded-xl p-3 text-center">
                <p className="text-lg">{t.icon}</p>
                <p className="text-xs text-muted-foreground mt-1">{t.label}</p>
                <p className="text-sm font-bold text-foreground">{t.value}</p>
              </div>
            ))}
          </div>
          <p className="text-xs text-muted-foreground text-center mt-3">تُعيَّن الأهداف من قِبَل المدير في Odoo</p>
        </div>
      </div>
    </div>
  );
}